import commonJsModule from "jaid-core"

export default commonJsModule.default